<template>
    <div id="program-occurrence-container" class="w-100">
        <b-row>
            <b-col class="col-sm-12 col-md-3">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="
                        this.isReadOnly
                            ? 'btn btn-primary my-3 btn-block'
                            : 'btn btn-primary my-3 btn-block btn-login'
                    "
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-bind:isReadOnly="isReadOnly"
                    v-on:click="addOccurrence"
                >
                </MdButton>
            </b-col>
            <b-col class="col-sm-12 col-md-9 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="searchOccurrence"
                            @keyup.enter="findOccurrence"
                        />
                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="findOccurrence"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <MdTablePaginationClient
                    v-bind:fields="fields"
                    v-bind:items="filtered"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    :deleteIconEvent="removeOccurrence"
                    v-bind:VisibleDeleteIcon="true"
                    :RowClick="RowClick"
                >
                </MdTablePaginationClient>
            </b-col>
        </b-row>

        <ModalTableMultiSelectServer
            v-bind:Resource="resourceParameter"
            v-bind:TypeOption="refCode"
            @getCodeConditionOK="onCodeConditionAdd($event)"
            @getCodeConditionCancel="onCodeConditionCancel($event)"
            v-bind:Fields="lookupFields"
            v-bind:FieldCode="'code'"
            v-bind:FieldDescription="'description'"
            v-bind:TitleWindow="$tc('Admission.Occurrence', 2)"
            v-bind:ModalId="modalId"
            v-bind:ReturnAll="true"
        ></ModalTableMultiSelectServer>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Utils from '@/common/utils.js';
import { EventBus } from '@/event-bus.js';

export default {
    name: 'ProgramOccurrence',
    mixins: [ShowMessage, DBFunctions],
    props: {
        value: {
            Type: Array,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    thStyle: { width: '92%' }
                }
            ],
            lookupFields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    thStyle: { width: '92%' }
                }
            ],
            pageOptions: [5, 10, 15],
            perPage: 10,
            currentPage: 1,
            searchOccurrence: '',
            search: {
                occurrence: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            resourceParameter: '',
            refCode: 'occurrence',
            modalId: Utils.generateUUID()
        };
    },
    computed: {
        filtered() {
            const search = (this.search.occurrence || '').trim().toLowerCase();
            const list = this.value || [];

            if (!search) {
                return list;
            }

            return list.filter(item => {
                const name = (item.name || '').toLowerCase();

                return name.includes(search);
            });
        },
        totalRows() {
            return this.filtered.length;
        },
        showMessageIsEmpty() {
            return this.totalRows === 0;
        },
        occurrenceAPI() {
            return 'occurrences';
        }
    },
    methods: {
        addOccurrence() {
            this.resourceParameter = '/' + this.occurrenceAPI;
            this.modelFilter = {
                code: 1,
                description: this.$t('programSetupListing.Title'),
                resource: this.occurrenceAPI
            };
            this.$bvModal.show(this.modalId);
        },

        removeOccurrence(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('programSetupListing.Title'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        const indexOf = this.value.indexOf(row);

                        if (indexOf !== -1) {
                            this.value.splice(indexOf, 1);
                            this.emitChange();
                        }
                    }
                });
        },

        onRowSelected() {},
        onFiltered() {},
        RowClick() {},

        pageChanged(page) {
            this.currentPage = page;
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            if (this.currentPage > this.totalRows / this.perPage) {
                this.currentPage = 1;
            }
        },

        onCodeConditionAdd(results) {
            this.$bvModal.hide(this.modalId);
            this.resourceParameter = '';

            if (!Array.isArray(results) || results.length === 0) {
                return;
            }

            for (let index = 0; index < results.length; index++) {
                const result = results[index];

                if (!result || !result.code) {
                    continue;
                }

                const code = result.code.trim();
                const indexOf = this.value.findIndex(test => test.code === code);

                if (indexOf === -1) {
                    this.value.push({ name: result.description, Occcode: code });
                    this.emitChange();
                }
            }
        },

        onCodeConditionCancel() {
            this.resourceParameter = '';
        },

        findOccurrence() {
            this.search.occurrence = this.searchOccurrence;
            this.currentPage = 1;
        },

        emitChange() {
            var changed = {
                Changed: true
            };
            EventBus.$emit('onChanged', changed);
        }
    }
};
</script>
